import { render, staticRenderFns } from "./taskView.vue?vue&type=template&id=5e625a03&"
import script from "./taskView.vue?vue&type=script&lang=js&"
export * from "./taskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports